<template>
  <TouchLayout @upload-setting="uploadSetting">
    <div class='main'>
        <div class='box-title'>
            <div class='title'>
                입장하실 이용권을 선택해주세요.
            </div>
            <button class='box-back' @click='back'>
                <div class='arrow-left'>
                </div>
                <div class='back-txt'>
                    이전 화면
                </div>
            </button>
        </div>
        <div class='box-list'>
            <div v-if='reserveList.length > 0'>
                <div v-for='(r,index) in reserveList' :key='index' class='card'>
                    <div class='left'
                        :class="{
                            private: r.ticketType == 'P',
                            ot: r.ticketType == 'O',
                            duet: r.ticketType == 'D',
                            coupon: r.ticketType == 'C',
                            group: r.ticketType == 'G',
                            member: r.ticketType == 'T',
                            wear: r.cp_ticket_type_cd == 'S',
                        }"
                    >
                    </div>
                    <div class='center'>
                        <div class='box-info'>
                            <div class='info-product-name'>
                                {{ convertTicket(r.ticketType) }} {{ r.productName }}
                            </div>
                            <div class='box-info-date'>
                                <div class='info-date'>
                                    {{ r.expireStartDate | timestampFilter4 }} ~ {{ r.expireEndDate | timestampFilter4 }}
                                </div>
                                <div class='info-expired'>
                                    {{ r.expireDays }}일 남음
                                </div>
                            </div>
                        </div>
                        <button class='btn-entrance' 
                            :disabled='isButtonDisable'
                            @click='touchEntrance(r)'>
                                입장하기
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 입장성공 팝업 -->
    <entrance-alert
        v-if='isEntranceSuccess'
        imgUrl='/img/icons/touch_success.png'
        :title='popTitle'
        :body='popBody'
        :expireDays='popExpireDays'
        body2='입장되었습니다. 오늘도 건강한 하루되세요!'
        :isTimeLimit='true'
        @close-popup='onClickSuccess'
    />

    <!-- 입장 불가능 얼럿 -->
    <image-alert
        v-if='isOpenNoEntrancePopup'
        imgUrl='/img/icons/touch_no_entrance.png'
        body1='일일 입장 1회 제한 입니다'
        body2='다시 확인해주세요.'
        :isTimeLimit='true'
        @close-popup='onClickNoEntranceAlert'
    />
  </TouchLayout>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';
import EntranceAlert from '@/components/EntranceAlert';
import TouchLayout from '@/layouts/TouchLayout';
import ImageAlert from '@/components/ImageAlert';

export default {
    name: 'touchReservationAttendance',
    components: {
      TouchLayout,
      EntranceAlert,
      ImageAlert,
    },
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            nowDate: moment().format('YYYY.MM.DD'),
            today: moment().format('YYYY-MM-DD'),
            nowTime: moment().format('hh:mm:ss'),
            centerCustomerId: this.$route.query.custId,
            centerCustomerName: this.$route.query.name,
            reserveList: '',
            reserveListOrg: '',
            customerInfo: {}, // 회원 정보
            centerId: this.$route.query.centerId,
            isEntranceSuccess: false,
            popTitle: '',
            popBody: '',
            popExpireDays: '',
            isButtonDisable: false,
            cardInfo: {},
            setting: {},
            isOpenNoEntrancePopup: false,

        };
    },
    mounted() {
        setInterval(
            () => {
                this.nowTime = moment().format('hh:mm:ss');
            }
            , 1000,
        );
        Promise.allSettled([
            this.fetchCustomerDetail(), // 회원정보 가져오기
            this.onSearchList()
        ]);
        this.speak('');
    },
    methods: {
        back() {
            this.$router.push({
                path: '/touch/reservation/main',
                query: {
                    centerId: this.centerId,
                    custId: this.centerCustomerId,
                    name: this.centerCustomerName,
                },
            });
        },
        async onSearchList() {
            try {
                let { data } = await this.getSearchLsit();
                console.log(data);

                // 입장하기 조건 
                data = data.filter( reserve => reserve.ticketType != 'S' && reserve.expirePlusType !== 'H' && ((reserve.ticketType ==='T') || (reserve.ticketType !== 'T' && !reserve.lessonDate && !reserve.noReservationEnterYn)));

                // 사용중 조건
                data = data.filter( reserve => moment().format('YYYY-MM-DD') >= moment(reserve.expireStartDate).format('YYYY-MM-DD') && moment().format('YYYY-MM-DD') <= moment(reserve.expireEndDate).format('YYYY-MM-DD') )

                // 만료일 가까운 순으로 정렬
                data.sort((a, b) => {
                    // 날짜 문자열을 Date 객체로 변환
                    const dateA = moment(a.expireEndDate);
                    const dateB = moment(b.expireEndDate);

                    // 날짜를 비교하여 정렬
                    return dateA - dateB;
                });

                // 원본 데이터
                this.reserveList = data;
                console.log(this.reserveList);

            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getSearchLsit() {
            return api.get(`/admin/api/center/${this.cId}/touch/monitor/customer/${this.centerCustomerId}/schedule/list`);
        },
        // 회원 정보 가져오기
        async fetchCustomerDetail() {
            try {
                const { data } = await this.sendGetCustomerDetail();
                this.customerInfo = data;
                for(let i in this.customerInfo.centerLockers) {
                    if(this.customerInfo.centerLockers[i].lockerStatus != 'F') {
                        this.customerInfo.centerLocker = this.customerInfo.centerLockers[i];
                        const rentEndedDay = moment(this.customerInfo.centerLocker.rentEndedAt);
                        const currentDate = moment();
                        this.customerInfo.centerLocker.rentRemainDays = rentEndedDay.diff(currentDate,"days")
                        // return (remainDays >= 0) ? `-${remainDays}` : String(remainDays).replace('-', '+');

                        break;
                    }
                }
            } catch (error) {
                alert('회원정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },
        // 회원 기본정보 조회 API 호출
        sendGetCustomerDetail() {
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.centerCustomerId}`);
        },
        convertTicket(val) {
            switch (val) {
                case 'P':
                    return '[개인]';
                    break;
                case 'O':
                    return '[OT]';
                    break;
                case 'D':
                    return '[듀엣]';
                    break;
                case 'G':
                    return '[그룹]';
                    break;
                case 'T':
                    return '[회원권]';
                    break;
            }
        },
        async touchEntrance(r) {
            // 팝업
            this.popTitle = this.convertTicket(r.ticketType) + r.productName;
            this.popBody = `${this.timestampFilter4(r.expireStartDate)} ~ ${this.timestampFilter4(r.expireEndDate)}`;
            this.popExpireDays = r.expireDays;

            // 카드
            this.cardInfo.cardCustomerName = `${r.centerCustomerName}`;
            this.cardInfo.cardProductCheckType = `입장`;
            this.cardInfo.cardCustomerImageUrl = this.customerInfo.imageUrl;
            this.cardInfo.cardProductName = `${this.convertTicket(r.ticketType)} ${r.productName}`;
            this.cardInfo.cardProductExpireDate = `이용권 만료일 ${this.timestampFilter(r.expireEndDate)}`;
            //console.log(this.cardInfo);

            const c = r.centerContractId;
            const p = r.centerProductId;
            const l = r.centerLessonScheduleId;

            try {
                this.isButtonDisable = true;
                const { data } = await this.fetchTouchEntrance(c, p, l);
                let  {rc, rm} = data;

                if (rc === true) {
                    this.isEntranceSuccess = true;
                    if(this.setting.openCardYn) {
                        this.callCard();
                    }
                    if(this.setting.soundOption != 'N') {
                        let soundType = 'T';
                        let speakMessage = "입장 완료 되었습니다.";
                        let count = 0;
                        
                        // 이용권 잔여횟수
                        if(r.lessonCountType === 'T') {
                            if(!r.contractSeq ) {
                                count = r.lessonCount;
                            }else {
                                count = r.lessonCount - r.contractSeq;
                            }
                        }else if(r.lessonCountType === 'W') {
                            count = r.lessonCount;
                        }else if(r.lessonCountType === 'U') {
                            count = 1000;
                        }

                        // 만료 알림음 조건
                        if( r.expireDays <= 7 || count <= 3 ) {
                            soundType = 'E';
                            speakMessage = "입장 완료 되었습니다. 이용권이 곧 종료 예정입니다.";
                        }

                        // 알림음 송출화면 체크
                        if( this.setting.soundFrom == 'T' ) {
                            if(this.setting.soundOption == 'S') {
                                this.speak(speakMessage);
                            }else if(this.setting.soundOption == 'M') {
                                if(soundType == 'T') {
                                    this.playAudio('attendance_entrance.mp3');
                                }else if(soundType == 'F') {
                                    this.playAudio('invalid_attendance_entrance.mp3');
                                }else if(soundType == 'E') {
                                    this.playAudio('expiring_attendance_entrance.mp3');
                                }
                            }
                        }else if( this.setting.soundFrom == 'A' ) {
                            this.callSound(this.setting.soundOption, soundType, speakMessage);
                        }else if( this.setting.soundFrom == 'B' ) {
                            if(this.setting.soundOption == 'S') {
                                this.speak(speakMessage);
                            }else if(this.setting.soundOption == 'M') {
                                if(soundType == 'T') {
                                    this.playAudio('attendance_entrance.mp3');
                                }else if(soundType == 'F') {
                                    this.playAudio('`invalid_attendance_entrance.mp3');
                                }else if(soundType == 'E') {
                                    this.playAudio('expiring_attendance_entrance.mp3');
                                }
                            }
                            this.callSound(this.setting.soundOption, soundType, speakMessage);
                        }
                    }
                } else {
                    rm = rm || '입장하지 못했습니다.';
                    if(this.setting.soundOption != 'N') {
                        this.speak(rm);
                    }
                    this.isOpenNoEntrancePopup = true;

                }
                this.isButtonDisable = false;
            } catch (e) {
                console.error(e);
                console.log('터치 에러입니다.');
            }
        },
        fetchTouchEntrance(c, p, l) {
            return api.post(`/admin/api/center/${this.cId}/touch/monitor/customer/${this.centerCustomerId}/touch/entrance`, {
                centerContractId: c,
                centerProductId: p,
                centerLessonScheduleId: l,
            });
        },
        onClickSuccess() {
            this.isEntranceSuccess = false;
            this.$router.push({ path: '/touch/main' });
        },
        // timestampTZ -> date (년-월-일)
        timestampFilter(value) {
            if (value === null || value === '' || value === undefined) {
                return value;
            }

            function addZero(target) {
                // 9 이하의 숫자는 0 붙이기
                const num = parseInt(target);
                const str = num > 9 ? num : `0${num}`;
                return str.toString();
            }

            const b = value.split(/\D/);
            --b[1];
            b[6] = b[6].substr(0, 3);
            const d = new Date(Date.UTC(...b));
            return `${d.getFullYear()}-${addZero(d.getMonth() + 1)}-${addZero(d.getDate())}`;
        },
        // timestampTZ -> date (년.월.일)(요일)
        timestampFilter4(value) {
            if (value === null || value === '' || value === undefined) {
                return value;
            }

            function addZero(target) {
                // 9 이하의 숫자는 0 붙이기
                const num = parseInt(target);
                const str = num > 9 ? num : `0${num}`;
                return str.toString();
            }

            const b = value.split(/\D/);
            --b[1];
            b[6] = b[6].substr(0, 3);
            const d = new Date(Date.UTC(...b));

            return `${d.getFullYear()}. ${addZero(d.getMonth() + 1)}. ${addZero(d.getDate())}`;
        },
        callCard() {
            return api.post(`${process.env.VUE_APP_SSE_URL}/sse/touch/monitor/alert/card`, {
                centerId: this.centerId,
                cardInfo: this.cardInfo,
            });
        },
        callSound(soundOption, soundType, speakMessage) {
            return api.post(`${process.env.VUE_APP_SSE_URL}/sse/touch/monitor/alert/sound`, {
                centerId: this.centerId,
                soundInfo: {soundOption, soundType, speakMessage},
            });
        },
        uploadSetting(data) {
            this.setting = data;    
        },
        playAudio(filename) {
            const audio = new Audio(`/audio/${filename}`);
            audio.play().catch(error => {
                console.error('Audio playback failed:', error);
            });
        },
        speak(text) {
            console.log("speak: ", text);
            try {
                const utterance = new SpeechSynthesisUtterance(text);
                window.speechSynthesis.speak(utterance);
            } catch (e) {
                console.error(e);
            }
        },
        onClickNoEntranceAlert() {
            this.isOpenNoEntrancePopup = false;
        },
    },
};
</script>

<style lang='scss' scoped>

    .box-title {
        width: 100%;
        max-width: 1200px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 16px;

        .title {
            font-family: Pretendard;
            font-size: 28px;
            font-weight: 700;
            line-height: 40px;
            letter-spacing: -0.6000000238418579px;
            text-align: left;
            color: #333333;
        }

        .box-back {
            display: flex;
            align-items: center;
            background-color: #F2F7FE;

            .arrow-left {
                width: 32px;
                height: 32px;
                background: url(/img/icons/arrow_left.png) no-repeat;
                background-position: center !important;
            }

            .back-txt {
                font-family: Pretendard;
                font-size: 28px;
                font-weight: 700;
                line-height: 40px;
                letter-spacing: -0.6000000238418579px;
                text-align: left;
                color: #808080;
            }
        }
    }

    .box-list {
        width: 100%;
        max-width: 1200px;
        height: calc(100% - 40px - 48px);
        overflow: auto;
    }

    .card {
        display: flex;
        align-items: stretch;
        margin-top: 24px;

        .left {
            width: 24px;
            border-radius: 16px 0px 0px 16px;
            background-color: #39B5B5;

            &.private {
                background-color: var(--ticket-private-color);
            }

            &.ot {
                background-color: var(--ticket-ot-color);
            }

            &.duet {
                background-color: var(--ticket-duet-color);
            }

            &.coupon {
                background-color: var(--ticket-coupon-color);
            }

            &.group {
                background-color: var(--ticket-group-color);
            }

            &.member {
                background-color: var(--ticket-member-color);
            }

            &.wear {
                background-color: var(--ticket-wear-color);
            }
        }

        .center {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: calc(100% - 24px);
            padding: 24px 32px;
            background-color: white;

            // 태블릿 (가로 해상도가 769px 보다 작은 화면에 적용)
            @media (max-width: 768px) {
                flex-direction: column;
                align-items: baseline;
            }

            .box-info {
                display: flex;
                flex-direction: column;

                .info-product-name {
                    font-family: Pretendard;
                    font-size: 32px;
                    font-weight: 700;
                    line-height: 32px;
                    letter-spacing: -0.6000000238418579px;
                    color: #535353;
                }

                .box-info-date {
                    display: flex;
                    align-items: center;
                    margin-top: 8px;

                    .info-date {
                        font-family: Pretendard;
                        font-size: 24px;
                        font-weight: 500;
                        line-height: 24px;
                        letter-spacing: -0.6000000238418579px;
                        color: #535353;
                    }

                    .info-expired {
                        font-family: Noto Sans CJK KR;
                        font-size: 20px;
                        font-weight: 500;
                        line-height: 24px;
                        letter-spacing: -0.6000000238418579px;
                        color: #3EC729;
                        padding: 4px 12px 4px 12px;
                        border-radius: 16px;
                        border: 1px solid #3EC729;
                        margin-left: 8px;

                        &.not {
                            color: #CCCCCC; 
                            border-color: #CCCCCC;
                        } 

                        &.late {
                            color: #F64444; 
                            border-color: #F64444;
                        } 
                    }
                }
            }

            .btn-entrance {
                width: 240px;
                height: 64px;
                padding: 8px 24px 8px 24px;
                border-radius: 8px 8px 8px 8px;
                background-color: #CCE4FC;
                font-family: Pretendard;
                font-size: 24px;
                font-weight: 500;
                line-height: 32px;
                letter-spacing: -0.005em;
                color: #0078F4;

                // 태블릿 (가로 해상도가 769px 보다 작은 화면에 적용)
                @media (max-width: 768px) {
                    width: 100%;
                    margin-top: 16px;
                }
            }
        }
    }

</style>
